import CrownForm from "./CrownForm";

const contactForm = document.querySelector<HTMLFormElement>("#contact-form");
const googleMap = document.querySelector("#google-map");
const form = document.querySelector(".quote-form");

if (googleMap && form) {
  new IntersectionObserver(
    (entries) => {
      form.classList[entries[0].isIntersecting ? "add" : "remove"]("formfade");
    },
    {
      threshold: 0.15,
    }
  ).observe(googleMap);
}

if (contactForm) {
  new CrownForm({
    el: contactForm,

    url: "/wp-content/themes/crownoil/ajax/Contact.php",

    button: {
      defaultText: "Call me back",
      submittingText: "Submitting...",
    },

    success() {
      window.location.href = "/thank-you-callback-request/";
    },
  });
}
